import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiFetchRecentTickets = (funcToDispatch, error) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/customerCreationTickets",
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "customerCreationTickets INDEX"),
  })
}

export const apiDeleteCustomer = (success, error) => {
  $.ajax({
    type: "DELETE",
    url: "/api/internal/deleteCustomerManager",
    success,
    error: wrapError(error, "apiDeleteCustomer"),
  })
}

export const apiCheckIfCustomerExists = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/deleteCustomerManager",
    success,
    error: wrapError(error, "apiCheckIfCustomerExists"),
  })
}

export const apiPostCustomerCreationTicket = (params, funcToDispatch, error, success) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/customerCreationTickets",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success: wrapSuccess(funcToDispatch, success),
    error: wrapError(error, "customerCreationTickets POST"),
  })
}

export const apiFetchCustomers = (funcToDispatch, error, success) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/customers",
    success: wrapSuccess(funcToDispatch, success),
    error: wrapError(error, "apiFetchCustomers"),
  })
}

export const apiInternalUpdateCustomer = (customerId, params, funcToDispatch, error, success) => {
  $.ajax({
    type: "PUT",
    url: `/api/internal/customers/${customerId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success: wrapSuccess(funcToDispatch, success),
    error: wrapError(error, "apiInternalUpdateCustomer"),
  })
}
